// extracted by mini-css-extract-plugin
export default {"topLocations":"_1CNi6","topLocations__title":"HoDEB","topLocations__collapsed":"_3Tbsg"};